
import { Component } from 'vue-property-decorator'
import AppButton from './AppButton.vue'

@Component
export default class AppButtonOutline extends AppButton {}
